export type Position = { col: number; row: number };
export type MapOffset = { x: number; y: number };

export const getHexPoints = (width: number) => [
  [0, width / 2],
  [width, 0],
  [2 * width, width / 2],
  [2 * width, (3 * width) / 2],
  [width, 2 * width],
  [0, (3 * width) / 2],
  [0, width / 2],
];

export const getHexCenter = (width: number) => {
  return { x: width, y: width };
};

export const getHexOffset = (
  ctx: CanvasRenderingContext2D | null,
  hexWidth: number,
) => {
  const offset = { x: 0, y: 0 };
  if (!ctx) return offset;
  const hexCenter = getHexCenter(hexWidth);
  const center = { x: ctx.canvas.width / 2, y: ctx.canvas.height / 2 };

  offset.x = center.x - hexCenter.x;
  offset.y = center.y - hexCenter.y;

  return offset;
};
